import React from "react";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import SignUpBanner from "../login/SignUpBanner";
import PrivacyBanner from "./PrivacyBanner";
import PrivacyPolicyContent from "./PrivacyPolicyContent";
class PrivacyPolicy extends React.Component {
  render() {
    return (
      <div>
        <PrivacyBanner />
        <PrivacyPolicyContent />
        <SignUpBanner />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/pages/privacyPolicy/index.js